import { render } from "./SwipeActionsListItem.vue?vue&type=template&id=70ed74a4&scoped=true"
import script from "./SwipeActionsListItem.vue?vue&type=script&lang=js"
export * from "./SwipeActionsListItem.vue?vue&type=script&lang=js"

import "./SwipeActionsListItem.vue?vue&type=style&index=0&id=70ed74a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70ed74a4"

export default script